import { shuffleArray } from "./helpers";

export class BagSystem {

    private items: any[] = [];
    private currentBag: any[] = [];

    constructor(items: any[]) {

        if (!this.items) {
            return null;
        }

        this.items = items;
        this.generateNewBag();
    }

    public getNext() {

        if (!this.currentBag) {
            return null;
        }

        if (this.currentBag.length <= 0) {
            this.generateNewBag();
        }

        const next = this.currentBag.shift();
        return next;
    }

    private generateNewBag() {
        if (!this.items) {
            return null;
        }

        this.currentBag = shuffleArray(this.items);
    }
}

export const bags: {
    monsters: BagSystem,
    bosses: BagSystem,
    backgrounds: BagSystem,
} = {
    monsters: null,
    bosses: null,
    backgrounds: null
};